import { Component, OnInit } from '@angular/core';
import { ThemeOptions } from '../../../../../theme-options';
import { Security } from '../../../../../utils/security.util';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioCadastrado } from 'src/app/models/usuario-cadastrado.model';

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
  providers: [UsuarioService]
})
export class UserBoxComponent implements OnInit {

  constructor(public globals: ThemeOptions, private router: Router, private usuarioService: UsuarioService) {
  }

  usuarioLogado: UsuarioCadastrado = null;
  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  ngOnInit() {

    this.usuarioService.getUsuarioCadastrado(Security.getUser().id).subscribe((response) => {
      this.usuarioLogado = response;

    });
  }

  logout(): void {
    Security.clear();
    this.router.navigate(['']);
  }

  public getSantizeUrl(fotoMimeType: string, foto: string) {

    const url = `data:${fotoMimeType};base64, ${foto}`;
    return this.usuarioService.bypassSecurityTrustUrl(url);
  }

}
